<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="800"
    :confirm-loading="submitLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form-model :model="formData" ref="form" class="form-wrapper new-project-modal">
      <a-form-model-item
      v-bind="formLayout"
      label="统计年月"
      prop="date"
      key="date"
      :rules="{ required: isEdit, message: '必填！'}">
        <a-month-picker v-if="isEdit" placeholder="选择年月" :allowClear="false" :format="monthFormat" :disabledDate="disabledDate" v-model="formData.date">
          <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
        </a-month-picker>
        <span v-else>{{formData.date}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="申请人"
      prop="applicant"
      key="applicant"
      :rules="{ required: false, message: ''}">
        <a-input
        v-model="formData.applicant"
        :maxLength="255"
        v-if="isEdit"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
        <span v-else>{{formData.applicant || '无'}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="收款方"
      prop="payee"
      key="payee"
      :rules="{ required: false, message: ''}">
        <a-input
        v-model="formData.payee"
        v-if="isEdit"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
        <span v-else>{{formData.payee || '无'}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="付款类型"
      prop="paymentId"
      key="paymentId"
      :rules="{ required: isEdit, message: '必填！'}">
        <a-select v-if="isEdit" placeholder="类型" v-model="formData.paymentId" :allowClear="true" class="project_sn">
          <a-select-option :value="item.id" v-for="(item,index) in payTypeList" :key="index">{{item.name}}</a-select-option>
        </a-select>
        <span v-else>{{ formData.paymentType || '无'}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="金额"
      prop="oaAmount"
      key="oaAmount"
      :rules="{ required: isEdit, message: '必填！'}">
        <a-input
        v-if="isEdit"
        type="number"
        v-model="formData.oaAmount"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
        <span v-else>{{formData.oaAmount}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="业务目的"
      prop="purpose"
      key="purpose"
      :rules="{ required: isEdit, message: '必填！'}">
        <a-input
        v-if="isEdit"
        v-model="formData.purpose"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
        <span v-else>{{formData.purpose || '无'}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="备注"
      prop="remark"
      key="remark"
      :rules="{ required: false}">
        <a-input
        v-if="isEdit"
        v-model="formData.remark"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
        <span v-else>{{formData.remark || '无'}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="供应商回票状态"
      prop="invoiceTrackStatus"
      key="invoiceTrackStatus"
      :rules="{ required: false, message: ''}">
        <a-select v-if="isEdit" v-model="formData.invoiceTrackStatus" :allowClear="true" class="project_sn">
          <a-select-option :value="item.key" v-for="(item,index) in invoiceTrackStatusList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <a-select v-if="!isEdit && formData.invoiceTrackStatus" :disabled="!isEdit"  v-model="formData.invoiceTrackStatus" :allowClear="true" class="project_sn">
          <a-select-option :value="item.key" v-for="(item,index) in invoiceTrackStatusList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <span v-else-if="!isEdit">无</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="发票日期"
      prop="invoiceDate"
      key="invoiceDate"
      :rules="{ required: false, message: ''}">
        <a-date-picker  v-if="isEdit"
        v-model="formData.invoiceDate" format="YYYY-MM-DD">
        </a-date-picker>
        <span v-else>{{formData.invoiceDate}}</span>
      </a-form-model-item>
    </a-form-model>
    <a-form-model-item
      v-bind="formLayout"
      label="上传发票">
      <div>
      <a-upload
        name="file"
        v-if="isEdit"
        :remove="handleRemove"
        :beforeUpload="beforeUpload"
        accept=".png, .jpg, .jpeg, .ppt, .pptx, .pdf, .doc, .docx, .xls, .xlsx, .xlsm, .xltx, .xltm, .xlsb, .xlam"
        :multiple="false"
        :fileList="fileList"
        action="/api/resource/uploadFile"
        :openFileDialogOnClick="fileList.length < 1"
        :showUploadList=false
      >
        <a-button :disabled="!isEdit || fileList.length >= 1">
          <a-icon type="upload" />上传附件
        </a-button>
      </a-upload>
      <span v-if="!isEdit && !loadedFileKeys"> 无</span>
      <span class="file-list">
        <p class="file" v-for="(file,index) in loadedFileKeys" :key="index">
          <span class="file-name">
            <a-icon type="file" />{{file.file_name}}
          </span>
          <a-icon class="download" style="padding-right: 8px" type="download" @click="download(file)" />
          <a-icon class="download" v-if="isEdit" type="delete" @click="handleRemove" />
        </p>
      </span>
      <p v-if="isEdit" class="upload-desc">支持文件类型：Excel，word，PDF ，PPT，图片（png，jpeg，jpg）；最多上传1个文件，单个文件不大于5M。</p>
      </div>
    </a-form-model-item>
  </a-modal>
</template>

<script>
/* eslint-disable eqeqeq */
import moment from 'moment';
import PriceAdminService from '@/services/PriceAdminService';
import SvgIcUpload from '@/assets/svg/ic-upload.svg';
import ProjectManageService from '../../services/ProjectManageService';
import {
  downloadFile
} from '../../utils/tools';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SvgIcUpload,
  },
  props: {
    visible: Boolean, // 是否弹窗可见[true, false]
    originFileList: Array,
    originLoadedFileKeys: Array,
    fileList: {
      type: Array,
      default() {
        return [];
      }
    },
    loadedFileKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    isEdit: Boolean,
    isNew: Boolean,
    formData: {
      type: Object,
      default() {
        return {
          date: undefined, // 日期
          applicant: undefined, // 申请人
          payee: undefined, // 收款方
          paymentId: undefined, // 付款类别
          oaAmount: undefined, // 结算金额
          purpose: undefined, // 业务目的
          remark: undefined, // 备注
          invoiceDate: undefined, // 发票日期
          file_list: [],
          invoiceTrackStatus: undefined,
          paymentType: '',
        };
      }
    },
  },
  computed: {
    title() {
      return this.isNew ? '增加PT费明细' : (this.isEdit ? '编辑PT费明细' : '查看PT费明细');
    },
  },
  data() {
    return {
      // fileList: _.cloneDeep(this.originFileList) || [],
      // loadedFileKeys: _.cloneDeep(this.originLoadedFileKeys) || [],
      submitLoading: false,
      payTypeList: [
        { id: 2, name: '交通费' },
        { id: 3, name: '通讯费' },
        { id: 4, name: '网络费' },
        { id: 5, name: '会议系统费' },
        { id: 6, name: '办公费' },
        { id: 7, name: '公共打印费' },
        { id: 8, name: '加班补助' },
        { id: 9, name: '银行手续费' },
        { id: 10, name: 'EDC费用' },
        { id: 11, name: 'SMO费用' }],
      monthFormat: 'YYYY-MM',
      formLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 17
        }
      },
      invoiceTrackStatusList: [
        { key: 1, val: '未追踪' },
        { key: 2, val: '部分回票' },
        { key: 3, val: '发票已回' },
      ],
    };
  },

  methods: {
    disabledDate(current) {
      return (
        current
        && (current > moment().endOf('day') || current < moment('20190501'))
      );
    },
    handleOk() {
      if (!this.isEdit) {
        this.$emit('cancel');
        return;
      }
      this.$refs.form.validate((err, fieldsValue) => {
        if (!err) {
          this.$Message.error('请完善数据');
          return;
        }
        const tempList = [];
        this.fileList.forEach((item) => {
          tempList.push({ file_key: item.file_key, file_name: item.name });
        });
        this.submitLoading = true;
        this.formData.file_list = tempList;
        if (typeof this.formData.date !== 'string' && this.formData.date) {
          this.formData.date = this.formData.date.format('YYYY-MM');
        }
        if (typeof this.formData.invoiceDate !== 'string' && this.formData.invoiceDate) {
          this.formData.invoiceDate = this.formData.invoiceDate.format('YYYY-MM-DD');
        }
        const request = this.isNew ? ProjectManageService.addPT : ProjectManageService.editPT;
        request(this.formData).then((res) => {
          this.submitLoading = false;
          if (res.status === 'success') {
            this.$emit('refresh');
            this.$Message.success(`${this.isNew ? '添加' : '更新'}成功`);
            this.$emit('cancel');
          } else {
            this.$Message.error(res.message);
          }
        });
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleRemove(file) {
      this.loadedFileKeys.splice(0);
      this.fileList.splice(0);
    },
    beforeUpload(file) {
      if (this.fileList.length >= 1) {
        this.$Message.error('只允许上传一个文件');
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 <= 5;
      let hasSameNameFile = false;
      if (!isLt5M) {
        this.$Message.error('单文件不能大于 5MB！');
        return false;
      }
      this.fileList.forEach((item) => {
        if (item.name === file.name) {
          hasSameNameFile = true;
          this.$Message.warning('该文件名与已上传文件名相同');
        }
      });
      if (isLt5M && !hasSameNameFile) {
        this.handleFileChange(file);
      }
      return false;
    },
    handleFileChange(file) {
      const formData = new FormData();
      formData.append('file', file);
      return PriceAdminService.uploadFile(formData)
        .then((res) => {
          if (res.status === 'success') {
            file.file_key = res.data.file_key;
            this.fileList = [];
            this.loadedFileKeys = [];
            this.fileList.push(file);
            this.$Message.success(`${file.name}上传成功！`);
            this.loadedFileKeys.push({
              file_key: res.data.file_key,
              file_name: file.name
            });
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.$Message.error(`${file.name}上传失败！`);
        });
    },
    download({ file_key, file_name }) {
      PriceAdminService.getFileLink({ file_key }).then((res) => {
        if (res.status === 'success') {
          downloadFile(res.data.url, file_name);
        } else {
          this.$Message.error(res.message.description);
        }
      }).catch((err) => {
        this.$Message.error(err.data.message.description);
      });
    },
  },
  mounted() {
    // ProjectManageService.paymentTypeList().then((res) => {
    //   if (res.status === 'success') {
    //     this.payTypeList = res.data;
    //   } else {
    //     this.$Message.error(res.message);
    //   }
    // });
  },
};
</script>

<style lang="less">
.file-required{
    .ant-form-item-label::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
}
}
.new-project-modal {
  padding: 8px 0;
  .ant-upload-disabled {
    .ant-btn-default {
      background: #efefef;
    }
  }
  .ant-form-item {
    margin-bottom: 13px;
  }
  .ant-form-item-control-wrapper {
    margin-left: 8px;
  }
  .file-list {
    display: block;
    margin-top: 8px;
    .file {
      cursor: pointer;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      line-height: 21px;
      height: 21px;
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
        display: inline-block;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .download {
        opacity: 0;
        position: absolute;
        right: 2px;
        margin: 4px 0 0 0;
        cursor: pointer;
        &:first-of-type {
          right: 20px;
        }
      }
      &:hover {
        background: #e6f9ff;
        .download {
          opacity: 1;
        }
      }
      .file-name {
        .anticon {
          margin-right: 4px;
        }
      }
    }
  }
}
.file-list {
    display: block;
    margin-top: 8px;
    .file {
      cursor: pointer;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      line-height: 21px;
      height: 21px;
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
        display: inline-block;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .download {
        opacity: 0;
        position: absolute;
        right: 2px;
        margin: 4px 0 0 0;
        cursor: pointer;
        &:first-of-type {
          right: 20px;
        }
      }
      &:hover {
        background: #e6f9ff;
        .download {
          opacity: 1;
        }
      }
      .file-name {
        .anticon {
          margin-right: 4px;
        }
      }
    }
  }
</style>
